var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.25H3.25V10.8333H10.8333V3.25Z",
    fill: "#6F6F6F",
    stroke: "#6F6F6F",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7498 3.25H15.1665V10.8333H22.7498V3.25Z",
    fill: "#6F6F6F",
    stroke: "#6F6F6F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7498 15.1667H15.1665V22.7501H22.7498V15.1667Z",
    fill: "#6F6F6F",
    stroke: "#6F6F6F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15.1667H3.25V22.7501H10.8333V15.1667Z",
    fill: "#6F6F6F",
    stroke: "#6F6F6F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostAlbum);
export default __webpack_public_path__ + "static/media/post-album.f0d63b773591406d5f2afc07cc74661c.svg";
export { ForwardRef as ReactComponent };